import React from 'react'

export default function (props) {

    const { onClick, width, height } = props

    return (

        <React.Fragment>

            <svg
                onClick={onClick}
                xmlns="http://www.w3.org/2000/svg"
                width={width ? width : 24}
                height={height ? height : 24}
                viewBox="0 0 24 24"
                fill="#0096D6">
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
            </svg>
        </React.Fragment>
    )


}